module.exports = __webpack_public_path__ + "static/img/4815_phase_function_Paper_Points.b0df5d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4815_phase_function_Paper_Points.png
// module id = rwTl
// module chunks = 0